import {
  toSectionCtaSingle,
  toSectionFeature,
  toSectionSlider
} from '@/lib/transformers'
import { Typo3SectionSpotSanityAccomodation } from '@/types/typo3'
import {
  SpotSanityDetail,
  SpotSanityList
} from '@/ui/components/SpotSanity/SpotSanity'
import { SectionCtaSingle, SectionFeature, SectionSlider } from '@/ui/Sections'
import { memo, Suspense } from 'react'

interface Props {
  data: Typo3SectionSpotSanityAccomodation
}

const SpotSanityAccomodation = ({ data }: Props) => {
  const layout = data?.plugin?.layout

  switch (layout) {
    case 'horizontal-with-images': {
      const sectionData = toSectionFeature(data)
      return <SectionFeature {...sectionData} variant="hotel" />
    }
    case 'photo-big': {
      const SectionData = toSectionCtaSingle(data)
      return <SectionCtaSingle {...SectionData} />
    }
    case 'photo-big-slide': {
      const sectionData = toSectionSlider(data)
      return <SectionSlider {...sectionData} />
    }
    case 'detail': {
      return <SpotSanityDetail data={data} variant="accomodation" />
    }
    default:
      return (
        <Suspense>
          <SpotSanityList data={data} storeType="accommodation" />
        </Suspense>
      )
  }
}

export default memo(SpotSanityAccomodation)
